export const SHOW_MESSAGE = "SHOW_MESSAGE"

export const show = (message, severity, summary) => ({
    type: SHOW_MESSAGE,
    message: { severity: severity, summary: summary, detail: message }
});